import { getConfigAmbiente } from '../../services/authentication/auth';

const useFundoPadraoHook = () => {
  const configAmbiente = getConfigAmbiente();

  const imgLogoLogin =
    configAmbiente && configAmbiente.imagens && configAmbiente.imagens.LOGO_ONESHELL
      ? configAmbiente.imagens.LOGO_ONESHELL
      : '';
  const imgBackground =
    configAmbiente && configAmbiente.imagens && configAmbiente.imagens.LOGIN_BACKGROUND
      ? configAmbiente.imagens.LOGIN_BACKGROUND
      : '';

  return {
    imgLogoLogin,
    imgBackground
  };
};

export default useFundoPadraoHook;
